import { useSelector } from '@xstate/react'
import { useUsersService } from 'providers'
import { AnyUserData } from 'types'

/**
 * Returns all the users in the usersService
 * @returns  object of users
 */
export const useUsers = (): { [id: string]: AnyUserData } => {
  const users = useSelector(
    // @ts-ignore
    useUsersService(),
    (state: any) => {
      return state.context.users
    }
  )
  return users
}
